import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import classNames from 'classnames'

import { getImageUrl } from '@/constants/images'

import styles from './index.module.scss'

const BottomTabNavigation = ({ activeTabId, customClass, onTabChange, tabs = [] }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname

  const getInitialActiveTab = () => {
    if (activeTabId) return activeTabId
    const matchingTab = tabs.find(tab => pathname === tab.route || pathname?.startsWith(tab.route))
    return matchingTab?.id || tabs[0]?.id || null
  }

  const [activeTab, setActiveTab] = useState(getInitialActiveTab)

  useEffect(() => {
    const matchingTab = tabs.find(tab => pathname === tab.route || pathname?.startsWith(tab.route))
    if (matchingTab?.id) {
      setActiveTab(matchingTab.id)
    }
  }, [pathname, tabs])

  useEffect(() => {
    if (activeTabId) {
      setActiveTab(activeTabId)
    }
  }, [activeTabId])

  const handleTabClick = tab => {
    if (tab.id) setActiveTab(tab.id)
    if (onTabChange) onTabChange(tab)
    if (tab.route && pathname !== tab.route) {
      navigate(tab.route)
    }
    if (tab.onClick) tab.onClick()
  }

  return (
    <>
      <div className={styles.tabFiller} />
      <nav
        className={classNames(
          styles.bottomTabContainer,
          customClass,
          'ew-d-flex',
          'ew-align-items-center',
          'ew-justify-content-between',
          'ew-bg-primary',
          'ew-position-fixed',
          'ew-w-100'
        )}>
        {tabs.map((tab, index) => {
          const isActive =
            activeTab === tab.id ||
            pathname === tab.route ||
            pathname?.startsWith(tab.route) ||
            tab.isActive ||
            (!activeTab && index === 0)
          return (
            <button
              className={classNames(
                styles.tabItem,
                'ew-d-flex',
                'ew-flex-column',
                'ew-align-items-center',
                'ew-justify-content-center',
                'ew-cursor-pointer',
                { [styles.active]: isActive }
              )}
              key={tab.id || index}
              onClick={() => handleTabClick(tab)}
              type='button'>
              <img
                alt={tab.label}
                height={24}
                src={getImageUrl(tab.icon)}
                style={{ filter: isActive ? 'invert(0)' : 'invert(1)' }}
                width={24}
              />
              {tab.label ? (
                <span
                  className={classNames(
                    styles.tabLabel,
                    isActive ? 'ew-fw-bold' : 'ew-color-secondary',
                    'ew-typography-tiny',
                    'ew-fw-regular',
                    'ew-mt-4'
                  )}>
                  {tab.label}
                </span>
              ) : null}
            </button>
          )
        })}
      </nav>
    </>
  )
}

export default BottomTabNavigation
